/**
 * @file thirdPartyBoard.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-26
 * @modified 2026-10-26
 * @description A Third-Party Delivery order planned on the transport board
 *              (Cam, 26 Oct 2026; the rule is the server's utils/thirdPartyBoard):
 *              its PO-D lines are rows (`third_party_board`), collected from
 *              the mill by the haulier linked in Transport Settings → Hauliers
 *              to the order's third-party haulier supplier, who also gets the
 *              PO-H. The words the boards show for such a row.
 */

/** The "Third-party" badge's tooltip on a board row. */
export function thirdPartyBadgeTitle(row) {
  if (!row) return '';
  const parts = ['Third-Party Delivery, planned here: the haulier collects the PO-D from the mill.'];
  if (row.third_party_supplier) parts.push(`Haulier supplier: ${row.third_party_supplier}.`);
  parts.push(row.third_party_haulage_po
    ? `Haulage order ${row.third_party_haulage_po} — the haulier's bill links to it.`
    : 'No PO-H raised yet — raise it from the order.');
  return parts.join('\n');
}
